import React, { Fragment, Suspense, useEffect } from 'react';
import { Route, Routes, HashRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import "nepali-datepicker-reactjs/dist/index.css";
import DefaultLayouts from './layouts/DefaultLayouts';
import AppLoading from './components/common/AppLoading';
import RequireAuth from './widgets/RequireAuth';
import LoginAuthPageView from "./views/auth/LoginAuthPageView";
import { useNavigate } from "react-router-dom";

const App = () => {
  const isTokenExpired = (token) => {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const exp = payload.exp * 1000; 
      return Date.now() > exp;
    } catch (e) {
      return true;
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token || isTokenExpired(token)) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token"); 
      navigate("/login", { replace: true });
    }
  }, []);
  return (
    <Fragment>
      <Suspense fallback={<AppLoading />}>
        <Routes>
          <Route path="/" element={<LoginAuthPageView />} />
          {/* <Route path="/renew-license" element={<RenewLicenseView />} /> */}
          <Route exact element={<RequireAuth />}>
            <Route path="*" element={<DefaultLayouts />} />
          </Route>
        </Routes>
      </Suspense>
      <Toaster />
    </Fragment>
  );
};

export default App;